module.exports = __webpack_public_path__ + "img/lang-30.6e76473a.jpg";